import { render } from "./SmallAsset.vue?vue&type=template&id=7c40d6ce"
import script from "./SmallAsset.vue?vue&type=script&lang=js"
export * from "./SmallAsset.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__